import state from '@/stores/widgets/state.js'
import mutations from '@/stores/widgets/mutations.js'
import actions from '@/stores/widgets/actions.js'

export default {
  state,
  mutations,
  actions
}
